import { useEffect, useRef } from 'react';
import WaveSurfer from 'wavesurfer.js';
import RecordPlugin from 'wavesurfer.js/dist/plugins/record.esm.js';
import { PURPLE_500 } from '../../../constants';
import { SpectrogramContainer, WaveformGlobalStyle, Wave } from './styled';

interface LiveSpectrogramProps {
    stream: MediaStream | null;
}

const LiveSpectrogram = ({ stream }: LiveSpectrogramProps) => {
    const waveRef = useRef<HTMLDivElement>(null);
    const wavesurferRef = useRef<WaveSurfer | null>(null);
    const recordRef = useRef<any>(null);
    const micStreamRef = useRef<any>(null);

    useEffect(() => {
        if (!stream || !waveRef.current) return undefined;

        const ws = WaveSurfer.create({
            container: waveRef.current,
            height: 40,
            barWidth: 1,
            barGap: 0,
            barRadius: 0,
            waveColor: PURPLE_500,
            progressColor: PURPLE_500,
            fillParent: true,
            cursorWidth: 0,
            normalize: true,
            interact: false,
        });

        const record = RecordPlugin.create({
            scrollingWaveform: true,
            continuousWaveform: false,
            renderRecordedAudio: false,
        });
        ws.registerPlugin(record);

        const micStream = record.renderMicStream(stream);
        micStreamRef.current = micStream;
        wavesurferRef.current = ws;
        recordRef.current = record;

        return () => {
            if (micStreamRef.current) {
                micStreamRef.current.onDestroy();
            }
            if (recordRef.current) {
                recordRef.current.stopMic();
            }
            if (wavesurferRef.current) {
                wavesurferRef.current.destroy();
            }
        };
    }, [stream]);

    return (
        <SpectrogramContainer>
            <WaveformGlobalStyle />
            <Wave ref={waveRef} id="dictate-wave" />
        </SpectrogramContainer>
    );
};

export default LiveSpectrogram;
